// extracted by mini-css-extract-plugin
module.exports = {"on":"Electrodes_on__pNS8U","off":"Electrodes_off__19qHC","link":"Electrodes_link__LuV4T"};